$(() => {
    const $modal = $('#entry_more_modal');

    $(document).on('click', '.js_entry_format_button', function () {
        const button = $(this);
        const content = button.next();

        $modal.find('.js_title').html(content.data('title'));

        if (content.html().length === 0) {
            $modal.find('.js_content').html('<p class="text-muted">Информация отсутствует</p>');
        } else {
            $modal.find('.js_content').html(content.html());
        }

        $modal.modal('show');
    });
});